"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = exports.tagsWithValue = exports.Tag = exports.allTags = exports.TagRecordOpen = exports.TagRecordClose = exports.TagRecord = void 0;
var parser_1 = require("./parser");
var tag_record_1 = require("./tag-record");
var types_1 = require("./types");
var tag_record_2 = require("./tag-record");
Object.defineProperty(exports, "TagRecord", { enumerable: true, get: function () { return tag_record_2.TagRecord; } });
Object.defineProperty(exports, "TagRecordClose", { enumerable: true, get: function () { return tag_record_2.TagRecordClose; } });
Object.defineProperty(exports, "TagRecordOpen", { enumerable: true, get: function () { return tag_record_2.TagRecordOpen; } });
var types_2 = require("./types");
Object.defineProperty(exports, "allTags", { enumerable: true, get: function () { return types_2.allTags; } });
Object.defineProperty(exports, "Tag", { enumerable: true, get: function () { return types_2.Tag; } });
Object.defineProperty(exports, "tagsWithValue", { enumerable: true, get: function () { return types_2.tagsWithValue; } });
function transform(str, callback) {
    var _a, _b, _c, _d;
    var tokenizer = new parser_1.Parser(str);
    var tags = [];
    var openTags = [];
    var match;
    var _loop_1 = function () {
        if (match.isEnd)
            return "break";
        if (!match.item)
            return "continue";
        var _e = match.item, element = _e.element, raw = _e.raw, start = _e.start, end = _e.end;
        if (element.type === parser_1.TagElementType.Open) {
            if (types_1.tagsAutoclose.includes(element.tag)) {
                var previousItem = openTags.findIndex(function (item) { return item.type === element.tag; });
                if (previousItem !== -1) {
                    var currentTag_1 = void 0;
                    while ((currentTag_1 = openTags.pop())) {
                        var closingTag = currentTag_1.close({
                            start: start,
                            end: start,
                            content: str.slice(currentTag_1.end, start)
                        });
                        if (openTags.length > 0) {
                            var before = openTags[openTags.length - 1];
                            before.children.unshift(closingTag);
                            currentTag_1.parent = before;
                        }
                        else {
                            tags.push(closingTag);
                        }
                        if (currentTag_1.type === element.tag) {
                            break;
                        }
                    }
                }
            }
            if (element instanceof parser_1.TagElementWithAttributes) {
                var tagWithAttr = new tag_record_1.TagRecordOpen({
                    type: element.tag,
                    raw: raw,
                    attributes: element.attributes,
                    start: start,
                    end: end
                });
                openTags.push(tagWithAttr);
            }
            else {
                var tagWithoutAttr = new tag_record_1.TagRecordOpen({
                    type: element.tag,
                    raw: raw,
                    start: start,
                    end: end
                });
                openTags.push(tagWithoutAttr);
            }
            if (types_1.tagsWithNoBody.includes(element.tag)) {
                var lastTag = openTags.pop();
                var closingTag = lastTag.close();
                if (openTags.length > 0) {
                    var before = openTags[openTags.length - 1];
                    before.children.unshift(closingTag);
                    lastTag.parent = before;
                }
                else {
                    tags.push(closingTag);
                }
            }
        }
        else if (element.type === parser_1.TagElementType.Close) {
            var lastTag = openTags[openTags.length - 1];
            if (element.tag === (lastTag === null || lastTag === void 0 ? void 0 : lastTag.type)) {
                openTags.pop();
                var closingTag = lastTag.close({
                    raw: raw,
                    start: start,
                    end: end,
                    content: str.slice(lastTag.end, start)
                });
                if (openTags.length > 0) {
                    var before = openTags[openTags.length - 1];
                    before.children.unshift(closingTag);
                    lastTag.parent = before;
                }
                else {
                    tags.push(closingTag);
                }
            }
        }
    };
    while ((match = tokenizer.next())) {
        var state_1 = _loop_1();
        if (state_1 === "break")
            break;
    }
    var remainingTag;
    while ((remainingTag = openTags.pop())) {
        var closingTag = remainingTag.close({
            start: str.length,
            end: str.length,
            content: str.slice(remainingTag.end, str.length)
        });
        if (openTags.length > 0) {
            var before = openTags[openTags.length - 1];
            before.children.unshift(closingTag);
            remainingTag.parent = before;
        }
        else {
            tags.push(closingTag);
        }
    }
    var flatTags = [];
    var currentTag;
    while ((currentTag = tags.shift())) {
        flatTags.push(currentTag);
        var queue = __spreadArray([], __read(currentTag.previous.children), false);
        var childTag = void 0;
        while ((childTag = queue.pop())) {
            flatTags.push(childTag);
            queue.push.apply(queue, __spreadArray([], __read(childTag.previous.children), false));
        }
    }
    var output = str;
    while ((currentTag = flatTags.pop())) {
        var offset = (_b = (_a = currentTag.previous.parent) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : 0;
        var content = (_d = (_c = currentTag.previous.parent) === null || _c === void 0 ? void 0 : _c.content) !== null && _d !== void 0 ? _d : output;
        var childContent = currentTag.previous.content;
        var startClosureIndex = currentTag.previous.start - offset;
        var endClosureIndex = Math.min(currentTag.end - offset, output.length);
        var left = content.substring(0, startClosureIndex);
        var right = content.substring(endClosureIndex);
        if (currentTag.previous.parent) {
            var transformed = callback(currentTag.previous, childContent);
            currentTag.previous.parent.content = left + transformed + right;
        }
        else {
            var transformed = callback(currentTag.previous, childContent);
            output = left + transformed + right;
        }
    }
    return output;
}
exports.transform = transform;
//# sourceMappingURL=index.js.map